export default function AccordingAttachmentIco() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="3.75" fill="#EBE1F9" />
      <path
        d="M6 9.4664C6 8.71966 6 8.3463 6.14533 8.06108C6.27315 7.8102 6.47713 7.60622 6.72801 7.4784C7.01323 7.33307 7.3866 7.33307 8.13333 7.33307H10.4497C10.7758 7.33307 10.9389 7.33307 11.0923 7.36991C11.2283 7.40257 11.3584 7.45644 11.4777 7.52955C11.6123 7.612 11.7276 7.7273 11.9582 7.95791L12.0418 8.04156C12.2724 8.27217 12.3877 8.38747 12.5223 8.46992C12.6416 8.54303 12.7717 8.5969 12.9077 8.62956C13.0611 8.6664 13.2242 8.6664 13.5503 8.6664H15.8667C16.6134 8.6664 16.9868 8.6664 17.272 8.81173C17.5229 8.93956 17.7269 9.14353 17.8547 9.39442C18 9.67963 18 10.053 18 10.7997V14.5331C18 15.2798 18 15.6532 17.8547 15.9384C17.7269 16.1893 17.5229 16.3933 17.272 16.5211C16.9868 16.6664 16.6134 16.6664 15.8667 16.6664H8.13333C7.38659 16.6664 7.01323 16.6664 6.72801 16.5211C6.47713 16.3933 6.27315 16.1893 6.14533 15.9384C6 15.6532 6 15.2798 6 14.5331V9.4664Z"
        stroke="#7F56D9"
        stroke-width="1.45455"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
